<template>
    <div class="app-body admin-accounts-page"
         id="view">
        <el-drawer
            id="adminAccountFilters"
            title="Filters"
            :visible.sync="filter_visible"
            custom-class="customer"
            direction="rtl">
            <div class="account-filters">
                <div class="mb-3">
                    <div class="form-label">
                        <label>Status</label>
                    </div>
                    <el-select v-model="filters.status"
                               class="w-full"
                               clearable
                               placeholder="Select a status"
                               @clear="clearStatus">
                        <el-option
                            v-for="item in statuses"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="mb-3">
                    <div class="form-label">
                        <label>Partner</label>
                    </div>
                    <company-selector
                        v-model="filters.reseller_id"
                        class="w-full"
                        placeholder="Select a partner"
                        clearable
                        filterable
                        :is_reseller="true"
                        @change="resellerChange">
                    </company-selector>
                </div>
                <div class="mb-3">
                    <div class="form-label">
                        <label>Accounts Cancelled or Suspended for a Month</label>
                    </div>
                    <el-select
                        class="w-full"
                        v-model="filters.abandoned_type"
                        clearable
                        placeholder="Select"
                        @change="abandonedTypeChange"
                        @clear="filters.abandoned_type = null">
                        <el-option
                            v-for="(label, key) in ['cancelled', 'suspended']"
                            :key="key"
                            :label="label.capitalize()"
                            :value="label">
                        </el-option>
                    </el-select>
                </div>
                <div class="mb-3">
                    <div class="form-label">
                        <label>A2P Registration Type</label>
                    </div>
                    <el-select
                        class="w-full"
                        v-model="filters.a2p_registration_type"
                        clearable
                        placeholder="Select"
                        @change="setA2PRegistrationType"
                        @clear="filters.a2p_registration_type = null">
                        <el-option
                            v-for="type in a2p_registration_types"
                            :key="type.value"
                            :label="type.label"
                            :value="type.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="mb-3">
                    <div class="form-label">
                        <label>LRN (Location Routing Number) Lookup Service</label>
                    </div>
                    <el-select class="w-full"
                               v-model="filters.lrn_lookup_enabled"
                               clearable
                               placeholder="Select"
                               @change="setLrnLookUpEnabled"
                               @clear="clearLrnLookup">
                        <el-option
                            v-for="type in lrn_lookup_options"
                            :key="type.value"
                            :label="type.label"
                            :value="type.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="mb-3">
                    <div>
                        <label>Active Accounts having no logins for 7 days</label>
                        <el-switch
                            v-model="filters.active_accounts_no_logins_7_days"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            @change="activeAccountsNoLoginsChange"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>Customer profile registered</label>
                        <el-switch
                            v-model="filters.registered_customer_profile"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>10DLC registered</label>
                        <el-switch
                            v-model="filters.registered_a2p_trust_bundle"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>Brand registered</label>
                        <el-switch
                            v-model="filters.registered_a2p_brand"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>STIR/SHAKEN registered</label>
                        <el-switch
                            v-model="filters.registered_stir_shaken"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>Voice Integrity registered</label>
                        <el-switch
                            v-model="filters.registered_voice_integrity"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>Address registered</label>
                        <el-switch
                            v-model="filters.registered_address"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>

                    <div>
                        <label>Compliance form submitted</label>
                        <el-switch
                            v-model="filters.submitted_compliance"
                            active-color="#00a344"
                            :active-value="1"
                            :inactive-value="switch_inactive"
                            class="pull-right">
                        </el-switch>
                    </div>
                </div>
            </div>
            <div class="d-flex pl-3 pr-3 admin-filter-button-container">
                <el-button
                    size="medium"
                    class="flex-grow-1 btn-block"
                    type="success"
                    :disabled="!hasFilterChanges"
                    @click="searchAccount()">
                    Apply Filters
                </el-button>
            </div>
        </el-drawer>
        <div class="py-3 px-3">
            <div class="row mb-3">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                    <el-input
                        placeholder="Search accounts..."
                        clearable
                        @keyup.enter.native="searchAccount(true)"
                        @clear="companies = []"
                        v-model="filters.search">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 pr-4 admin-buttons-container">
                    <div class="admin-buttons-inner">
                        <div class="row">
                            <template class="mr-3"
                                      v-if="!isReseller && canSeeHeaderButtons">
                                <div class="filter-buttons">
                                    <el-button
                                        v-if="notEmptyFilters"
                                        size="medium"
                                        ref="reset_button"
                                        @click.native="resetFilters">
                                        Reset Filters
                                    </el-button>
                                    <el-button
                                        type="default"
                                        size="medium"
                                        class="mr-2"
                                        @click="filter_visible = !filter_visible">
                                        Filters
                                        <span
                                            class="badge badge-pill badge-danger"
                                            v-if="filterCount > 0">
                                            {{ filterCount }}
                                        </span>
                                    </el-button>
                                </div>
                            </template>

                            <div class="mr-1 pb-2"
                                 v-if="canSeeAddAccountButton">
                                <router-link
                                    :to="{ name: 'Add User' }"
                                    tag="button"
                                    class="btn greenish">
                                    <i class="fa fa-plus"></i>
                                    Add Account
                                </router-link>
                            </div>
                            <el-button-group
                                v-if="isReseller">
                                <el-button
                                    size="medium"
                                    :type="filters.reseller_filter_status === 'active' ? 'success' : 'default'"
                                    @click="resellerSearchAccount('active')">
                                    Active
                                </el-button>
                                <el-button
                                    size="medium"
                                    :type="filters.reseller_filter_status === 'suspended' ? 'success' : 'default'"
                                    @click="resellerSearchAccount('suspended')">
                                    Suspended
                                </el-button>
                            </el-button-group>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card p-3"
                 id="container-table-accounts"
                 v-loading="searching">

                <div v-if="total > 0">
                    <h5 class="font-weight-300">{{ total }} {{
                            total > 1 ? 'accounts' : 'account'
                        }} matched</h5>
                </div>
                <table class="table table-bordered"
                       id="table-accounts"
                       v-if="companies.length > 0">
                    <thead>
                    <tr>
                        <th>Company</th>
                        <th>Billing Admin</th>
                        <th v-if="!isReseller">CSM Rep</th>
                        <th v-if="!isReseller">Sales Rep</th>
                        <th v-if="!isReseller">Reseller</th>
                        <th v-if="!isReseller">Billing</th>
                        <th>Created At</th>
                        <th>User last Login</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(company, i) in companies">
                        <td>
                            <div class="media">
                                <div class="media-body">
                                    <div><strong>{{ company.name }}</strong></div>
                                    <div>#{{ company.id }}</div>
                                    <hr style="border-color: #fdfdfd">
                                    <div class="text-xs"
                                         v-if="isReseller">
                                        <b>Form Capture Token:</b>
                                        <div>{{ company.form_capture_token }}</div>
                                        <template v-if="company.master_api_token">
                                            <b>Master API Token:</b>
                                            <div>{{ company.master_api_token }}</div>
                                        </template>
                                    </div>
                                    <b class="label bluish"
                                       v-if="company.is_reseller">
                                        Reseller
                                    </b>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="media mb-2"
                                 v-for="billing_admin in company.billing_admins">
                                <div class="media-body">
                                    <div><strong>{{ billing_admin.first_name }} {{ billing_admin.last_name }}</strong>
                                    </div>
                                    #{{ billing_admin.id }}

                                    <div>
                                        <div>{{ billing_admin.email }}</div>
                                        <div>{{ billing_admin.phone_number }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!company.billing_admins">
                                -
                            </div>
                        </td>
                        <td v-if="!isReseller"> <!-- CSM Rep -->
                            <div class="media"
                                 v-if="company.csm_rep">
                                <div class="media-body">
                                    <div><strong>{{ company.csm_rep.name }}</strong></div>
                                    #{{ company.csm_rep.id }}
                                    <div>
                                        <div>{{ company.csm_rep.email }}</div>
                                        <div>{{ company.csm_rep.phone_number }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!company.csm_rep">
                                -
                            </div>

                            <!-- HubSpot Business Segment -->
                            <div class="media b-t pt-3"
                                 v-if="company.hubspot_business_segment">
                                <div class="media-body">
                                    <div>HubSpot CftSegment: <strong>{{ company.hubspot_business_segment }}</strong></div>
                                </div>
                            </div>
                        </td>
                        <td v-if="!isReseller"> <!-- Sales Rep -->
                            <div class="media"
                                 v-if="company.sales_rep">
                                <div class="media-body">
                                    <div><strong>{{ company.sales_rep.name }}</strong></div>
                                    #{{ company.sales_rep.id }}
                                    <div>
                                        <div>{{ company.sales_rep.email }}</div>
                                        <div>{{ company.sales_rep.phone_number }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!company.sales_rep">
                                -
                            </div>
                        </td>
                        <td v-if="!isReseller">
                            <a v-if="company.reseller_company"
                               href="#"
                               @click.prevent="searchReseller(company.reseller_company.id)">
                                <div class="media a-primary">
                                    <div class="media-body">
                                        <div><strong>{{ company.reseller_company.name }}</strong></div>
                                        #{{ company.reseller_company.id }}
                                    </div>
                                </div>
                            </a>
                            <div v-if="!company.reseller_company">
                                -
                            </div>
                        </td>
                        <td v-if="!isReseller">
                            <b class="label orangish">
                                Auto Collection: {{ company.chargebee_auto_collection ? 'On' : 'Off' }}
                            </b>
                            <b class="label yellow">Payment Grace Period: {{ company.payment_grace_period }} days</b>
                        </td>
                        <td>
                            <!-- Created At -->
                            <div class="media">
                                <div class="media-body">
                                    {{ company.created_at | fixDateTime }}
                                </div>
                            </div>

                            <!-- Account Creator -->
                            <div class="media b-t pt-3"
                                 v-if="company.creator_admin">
                                <div class="media-body">
                                    <div>Created by: <strong>{{ company.creator_admin.name }}</strong></div>
                                    #{{ company.creator_admin.id }}
                                    <div>
                                        <div>{{ company.creator_admin.email }}</div>
                                        <div>{{ company.creator_admin.phone_number }}</div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div v-if="company.last_login_user">
                                <div>{{ company.last_login_user.full_name }}</div>
                                <small>{{ company.last_login_user.last_login | fixDateTime }}</small>
                            </div>
                            <div v-else>-</div>
                        </td>
                        <td>
                            <template v-if="company.subscription && company.subscription.status">
                                <p>
                                    <span>Chargebee Status: </span>
                                    <strong :style="getSubscriptionStyle(company.subscription.status)">{{ getSubscriptionStatus(company.subscription.status) }}</strong>
                                </p>
                                <hr>
                            </template>

                            <template v-if="isReseller">
                                <strong v-if="company.status_label === 'Active (No Subscription)'"
                                        class="text-green">
                                    Active
                                </strong>
                                <strong v-else-if="company.status_label !== 'Trial Purge Eligible'"
                                        class="mb-2"
                                        :style="'color:' + status_colors[company.status_label]">
                                    {{ company.status_label }}
                                </strong>
                                <strong class="mb-2"
                                        v-else
                                        :style="'color:' + status_colors['Trial Expired']">
                                    Trial Expired
                                </strong>
                            </template>

                            <template v-if="!isReseller">
                                <strong class="mb-2"
                                        v-if="company.status_label !== 'Trial Purge Eligible'"
                                        :style="'color:' + status_colors[company.status_label]">
                                    {{ company.status_label }}
                                </strong>
                                <strong class="mb-2"
                                        v-else
                                        :style="'color:' + status_colors['Trial Expired']">
                                    Trial Expired
                                </strong>
                            </template>

                            <p class="mb-1"
                               v-if="!company.enabled">
                                <b class="label danger text-left"
                                   v-if="isReseller">
                                    <p class="mb-1">
                                        Suspended by Aloware
                                    </p>
                                    <span>{{ company.suspended_at | fixDateTime }}</span>
                                </b>
                                <b class="label danger text-left"
                                   v-else-if="company.suspender">
                                    <p class="mb-1">
                                        Suspended by {{ company.suspender.name }} - #{{ company.suspender.id }}
                                    </p>
                                    <span>{{ company.suspended_at | fixDateTime }}</span>
                                </b>
                                <b class="label danger text-left"
                                   v-else>
                                    <p class="mb-1">
                                        Suspended
                                    </p>
                                    <span>{{ company.suspended_at | fixDateTime }}</span>
                                </b>
                            </p>

                            <div v-if="['In Trial', 'Trial Expired', 'Trial Purge Eligible'].includes(company.status_label)"
                                 class="small mb-2">
                                <div>
                                    <strong>Started at:</strong>
                                    <span v-if="company.trial_start_at">{{ company.trial_start_at | fixDateTime }}</span>
                                    <span v-else>-</span>
                                </div>
                                <div>
                                    <strong>Ends at:</strong>
                                    <span v-if="company.trial_ends_at">{{ company.trial_ends_at | fixDateTime }}</span>
                                    <span v-else>-</span>
                                </div>
                                <div v-if="company.trial_remaining_days > 0">
                                    <strong>
                                        Status:
                                    </strong>
                                    {{ company.trial_remaining_days }} {{ company.trial_remaining_days > 1 ? 'days' : 'day' }} remaining
                                </div>
                                <div v-if="company.trial_remaining_days <= 0">
                                    <strong>Status:</strong> Expired
                                </div>
                            </div>

                            <template v-if="company.status_label === 'Trial Purge Eligible'">
                                <hr>
                                <strong :style="'color:' + status_colors[company.status_label]">
                                    {{ company.status_label }}
                                </strong>
                                <div class="small">
                                    <strong>From:</strong>
                                    <span v-if="company.trial_ends_at">{{ getTrialPurgeDate(company) | fixDateTime }}</span>
                                    <span v-else>-</span>
                                </div>
                            </template>
                        </td>
                        <td class="text-right"
                            :style="{'width': '180px;'}">
                            <router-link class="btn btn-sm btn-block dark-greenish"
                                         :to="{ name: 'Account', params: { id: company.id } }">
                                Open Card
                            </router-link>
                            <el-tooltip
                                effect="dark"
                                :content="getImpersonateDisabledReason(company)"
                                placement="top"
                                :disabled="!getImpersonateDisabledReason(company)">
                                <button class="btn btn-sm btn-block purple-800"
                                        :disabled="!!getImpersonateDisabledReason(company)"
                                        @click="impersonate(company)">
                                    Impersonate
                                </button>
                            </el-tooltip>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-else>
                    <div class="message-centered">
                        <div v-if="!searching && (filterCount > 0 || last_search.length > 0)">
                            <i class="fa fa-heartbeat"></i>
                            No results found
                        </div>
                        <div v-else>
                            <i class="fa fa-search"></i>
                            Search accounts
                        </div>
                    </div>
                </div>
                <div class="mt-3"
                     v-if="companies.length > 0 && total > per_page">
                    <el-pagination :page-size="per_page"
                                   :page-sizes="[25, 50, 100, 250]"
                                   :total="total"
                                   background
                                   class="pull-right"
                                   layout="sizes, prev, pager, next"
                                   @current-change="changePage"
                                   @size-change="handleSizeChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../../auth'
import _ from 'lodash'
import {mapActions, mapState} from 'vuex'
import CompanySelector from "../../components/company-selector"
import { acl_mixin, subscription_style_mixin, prompt_mixin, reseller_mixin } from '../../mixins'
import moment from 'moment'
import * as Company from '../../constants/company'
import * as Plan from '../../../user/constants/plan'

export default {
    components: {CompanySelector},
    mixins: [
        subscription_style_mixin,
        acl_mixin,
        prompt_mixin,
        reseller_mixin,
    ],
    data() {
        return {
            auth: auth,
            searching: false,
            dev_user_id: null,
            demo_user_id: null,
            last_search: '',
            filter_visible: false,
            empty_filters: {
                search: '',
                status: null,
                reseller_id: null,
                abandoned_type: null,
                active_accounts_no_logins_7_days: 0,
                registered_customer_profile: 0,
                registered_a2p_trust_bundle: 0,
                registered_a2p_brand: 0,
                registered_stir_shaken: 0,
                registered_voice_integrity: 0,
                registered_address: 0,
                submitted_compliance: 0,
                a2p_registration_type: null,
                lrn_lookup_enabled: null,
            },
            filters: {},
            companies: [],
            status_colors: {
                ['Active']: '#4CAF50',
                ['Active (No Subscription)']: '#c0ca33',
                ['Cancelled']: '#b71c1c',
                ['In Trial']: '#00ccff',
                ['Trial Expired']: '#FF9800',
                ['Trial Purge Eligible']: '#e600ff'
            },
            per_page: 25,
            current_page: 1,
            total: 0,
            switch_inactive: 0,
            a2p_registration_types: [
                {
                    value: 0,
                    label: 'All'
                },
                {
                    value: Company.A2P_REGISTRATION_TYPE_STARTER,
                    label: 'Starter'
                },
                {
                    value: Company.A2P_REGISTRATION_TYPE_STANDARD,
                    label: 'Standard'
                },
            ],
            lrn_lookup_options: [
                {
                    value: 'true',
                    label: 'Enabled'
                },
                {
                    value: 'false',
                    label: 'Disabled'
                }
            ],
            login_loading: false,
            Company,
            Plan
        }
    },

    computed: {
        ...mapState(['account_filters']),

        filterCount() {
            let count = 0
            for (const [key, value] of Object.entries(this.filters)) {
                if (value && key !== 'search') {
                    count++
                }
            }

            return count;
        },

        // checks if there are filters applied and are stored in our vuex
        hasFilterChanges() {
            for (let x in this.filters) {
                if (this.filters[x] !== this.account_filters[x]) {
                    return true
                }
            }

            return false
        },

        // checks if filter is not empty
        notEmptyFilters() {
            return JSON.stringify(this.filters) !== JSON.stringify(this.empty_filters)
        },
    },

    mounted() {
        this.filters = _.cloneDeep(this.account_filters)
        if (this.isReseller) {
            this.filters.reseller_filter_status = 'active'
        }

        this.dev_user_id = localStorage.getItem('dev_user_id')
        this.demo_user_id = localStorage.getItem('demo_user_id')

        // apply filter on page load if user is reseller or it is navigated from the view page
        // back to the list page
        if (this.isReseller || this.notEmptyFilters) {
            this.searchAccount()
        }
    },

    methods: {
        getTrialPurgeDate(company) {
            return moment.utc(company.trial_ends_at).add(Plan.STANDARD_TRIAL_PERIOD, Plan.STANDARD_TRIAL_PERIOD_UNIT)
        },

        getImpersonateDisabledReason(company) {
            if (company.is_reseller) {
                if (!company.reseller_admins || company.reseller_admins.length === 0) {
                    return 'No reseller admins available to impersonate.'
                }
                return null
            }
            if (!company.billing_admins || company.billing_admins.length === 0) {
                return 'No billing admins available to impersonate.'
            }
            return null
        },

        resellerSearchAccount(status = 'active') {
            this.filters.reseller_filter_status = status
            this.searchAccount()
        },

        searchAccount() {
            let search = this.filters.search.trim()

            // Only search when filter has been changed or search is set
            if (this.notEmptyFilters) {
                this.switch_inactive = 0
                this.last_search = search
                this.searching = true
                const paginate = {
                    page: this.current_page,
                    per_page: this.per_page
                }

                let params = _.clone(this.filters)
                for (const [key, value] of Object.entries(params)) {
                    if (!value) {
                        delete params[key]
                    }
                }
                axios.get('/api/admin/accounts', {
                    params: Object.assign(paginate, params)
                }).then(res => {
                    this.current_page = res.data.current_page
                    this.total = res.data.total
                    this.companies = res.data.data
                    this.searching = false

                    this.filter_visible = false
                }).catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)

                    this.searching = false
                    this.filter_visible = false
                })
            } else {
                this.searching = false
                this.filter_visible = false
                this.last_search = ''
                this.companies = []
            }

            this.setAccountFilters(_.cloneDeep(this.filters))
        },

        clearStatus() {
            this.filters.status = null
        },

        clearLrnLookup() {
            this.filters.lrn_lookup_enabled = null
        },

        resellerChange(reseller_company_id) {
            if (!reseller_company_id) {
                this.filters.reseller_id = null

                return
            }

            this.filters.reseller_id = reseller_company_id
        },

        searchReseller(reseller_company_id) {
            this.filters.reseller_id = reseller_company_id
            this.searchAccount()
        },

        abandonedTypeChange(abandoned_type) {
            if (abandoned_type == 'suspended') {
                this.filters.active_accounts_no_logins_7_days = null
            }
        },

        activeAccountsNoLoginsChange(value) {
            if (value && this.filters.abandoned_type == 'suspended') {
                this.filters.abandoned_type = null
            }
        },

        resetFilters() {
            this.filters = _.clone(this.empty_filters)
            if (this.isReseller) {
                this.filters.reseller_filter_status = 'active'
            }

            this.setAccountFilters(_.cloneDeep(this.filters))
            this.companies = []

            this.$refs.reset_button.$el.blur();
            // Reset page data total count
            this.total = 0
        },

        impersonate(company = null, user_id = null) {
            let default_page = '/'
            let is_reseller = false

            if (company && company.is_reseller) {
                is_reseller = true
                default_page = '/admin'
                user_id = company.reseller_admins[0].id
            }

            if (company && !company.is_reseller) {
                user_id = company.billing_admins[0].id
            }

            this.promptImpersonation(is_reseller).then(reason => {
                let win = window.open('', '_blank')

                window.oldOpen = window.open
                window.open = function (url) {
                    win.location = url
                    window.open = oldOpen
                    win.focus()
                }

                this.auth.impersonate(user_id, is_reseller, reason).then(res => {
                    if (res.data?.app_url) {
                        default_page = res.data.app_url
                    }

                    window.open(default_page)
                }).catch(err => {
                    this.$notify.error({
                        title: 'Error impersonating user',
                        message: err?.response?.data?.error ?? Object.values(err?.response?.data?.errors ?? {}).flat()[0] ?? 'Error impersonating user',
                    })
                    window.open = oldOpen
                    win.close()
                })
            })
        },

        suspend(company) {
            this.$prompt('Why you are suspending this account?', 'Suspend Account', {
                confirmButtonText: 'Suspend',
                cancelButtonText: 'Cancel'
            }).then(({value}) => {
                if (!value) {
                    this.$notify.error({
                        title: 'Error',
                        message: 'You can not suspend an account without a reason.'
                    })
                    return
                }

                axios.post('/api/admin/company/' + company.id + '/suspend', {
                    reason: value
                }).then(res => {
                    this.resellerSearchAccount('active')
                    this.$notify({
                        offset: 75,
                        title: 'Account',
                        message: res.data.message,
                        type: 'success'
                    })

                    this.companies.map(c => {
                        if (c.id === company.id) {
                            c.enabled = false
                            return c
                        }
                        return c
                    })
                }).catch(err => {
                    this.$notify({
                        title: 'Error',
                        message: err.response.data.message,
                        type: 'error',
                        showClose: true,
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        },

        changePage(val) {
            this.current_page = val
            this.searchAccount()
        },

        handleSizeChange(val) {
            this.current_page = 1
            this.per_page = val
            this.searchAccount()
        },

        setA2PRegistrationType(val) {
            this.filters.a2p_registration_type = val
        },

        setLrnLookUpEnabled(val) {
            this.filters.lrn_lookup_enabled = val
        },

        ...mapActions(['setAccountFilters'])
    },

    watch: {
        'filters.search': function () {
            // reset the search results upon clearing the search input
            if (this.filters.search.trim() == '') {
                this.searchAccount()
                this.companies = []
                this.total = 0
            }
        }
    },

    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next()
            })
            .catch((err) => {
                next({name: 'Login', query: {redirect: to.fullPath}})
            })
    }
}
</script>
